import { useScrollAnimation } from "../../../hooks/useScrollAnimation";

export default function Rebates() {
  const { ref: imageRef, isVisible: imageVisible } = useScrollAnimation();
  const { ref: contentRef, isVisible: contentVisible } = useScrollAnimation();

  return (
    <section id="rebates" className="py-16 lg:py-24 bg-white">
      <div className="max-w-[1400px] mx-auto px-4 sm:px-6">
        <div className="grid lg:grid-cols-2 gap-10 lg:gap-16 items-center">
          <div
            ref={imageRef}
            className="relative"
            style={{
              opacity: imageVisible ? 1 : 0,
              transform: imageVisible ? 'translateX(0) scale(1)' : 'translateX(-40px) scale(0.95)',
              transition: 'opacity 0.8s cubic-bezier(0.22, 1, 0.36, 1), transform 0.8s cubic-bezier(0.22, 1, 0.36, 1)',
            }}
          >
            <img
              src="https://public.readdy.ai/ai/img_res/24efbcc1c37da92724a0e52e974e224b.jpg"
              alt="Florida Energy Rebates"
              className="w-full h-auto rounded-3xl shadow-2xl max-h-[400px] lg:max-h-none object-cover"
            />
          </div>

          <div
            ref={contentRef}
            style={{
              opacity: contentVisible ? 1 : 0,
              transform: contentVisible ? 'translateX(0)' : 'translateX(40px)',
              transition: 'opacity 0.8s cubic-bezier(0.22, 1, 0.36, 1) 0.15s, transform 0.8s cubic-bezier(0.22, 1, 0.36, 1) 0.15s',
            }}
          >
            <div className="inline-block bg-brand-red-light text-brand-red px-4 py-2 rounded-full text-sm font-semibold mb-6">
              SAVE EVEN MORE
            </div>
            <h2 className="text-3xl sm:text-4xl lg:text-5xl xl:text-6xl font-bold text-gray-900 mb-4 lg:mb-6 leading-tight">
              Florida Energy Rebates &amp; Incentives
            </h2>
            <p className="text-base lg:text-lg text-gray-600 mb-6 lg:mb-8">
              Take advantage of federal, state, and local incentives to maximize your savings on
              energy-efficient home improvements. Our team helps you navigate all available
              programs.
            </p>

            <div className="space-y-3 sm:space-y-4 mb-6 lg:mb-8">
              <div className="flex items-start gap-4">
                <div className="w-8 h-8 flex items-center justify-center flex-shrink-0 bg-brand-red-light rounded-lg mt-1">
                  <i className="ri-check-line text-brand-red text-xl"></i>
                </div>
                <div>
                  <h4 className="font-semibold text-gray-900 mb-1">
                    Federal Solar Tax Credit (30%)
                  </h4>
                  <p className="text-gray-600 text-sm">
                    Claim 30% of your solar installation costs as a federal tax credit through 2032.
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="w-8 h-8 flex items-center justify-center flex-shrink-0 bg-brand-red-light rounded-lg mt-1">
                  <i className="ri-check-line text-brand-red text-xl"></i>
                </div>
                <div>
                  <h4 className="font-semibold text-gray-900 mb-1">
                    Florida Solar Rights Act
                  </h4>
                  <p className="text-gray-600 text-sm">
                    Property tax exemption for solar installations and protection of your right to
                    solar access.
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="w-8 h-8 flex items-center justify-center flex-shrink-0 bg-brand-red-light rounded-lg mt-1">
                  <i className="ri-check-line text-brand-red text-xl"></i>
                </div>
                <div>
                  <h4 className="font-semibold text-gray-900 mb-1">
                    Utility Company Rebates
                  </h4>
                  <p className="text-gray-600 text-sm">
                    FPL, Duke Energy, and TECO offer rebates up to $1,500 for high-efficiency HVAC
                    systems.
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="w-8 h-8 flex items-center justify-center flex-shrink-0 bg-brand-red-light rounded-lg mt-1">
                  <i className="ri-check-line text-brand-red text-xl"></i>
                </div>
                <div>
                  <h4 className="font-semibold text-gray-900 mb-1">
                    Energy-Efficient HVAC Incentives
                  </h4>
                  <p className="text-gray-600 text-sm">
                    Federal tax credits up to $2,000 for qualifying heat pumps and AC systems.
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="w-8 h-8 flex items-center justify-center flex-shrink-0 bg-brand-red-light rounded-lg mt-1">
                  <i className="ri-check-line text-brand-red text-xl"></i>
                </div>
                <div>
                  <h4 className="font-semibold text-gray-900 mb-1">
                    Insulation Tax Credits
                  </h4>
                  <p className="text-gray-600 text-sm">
                    Claim up to $1,200 annually for qualifying insulation improvements under the
                    Inflation Reduction Act.
                  </p>
                </div>
              </div>
            </div>

            <a
              href="#contact"
              className="inline-flex items-center gap-2 border-2 border-brand-navy text-brand-navy px-6 py-3 rounded-full font-semibold hover:bg-brand-navy hover:text-white transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              View Complete Rebate Guide
              <i className="ri-arrow-right-line"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
